import { Navigate, Route, Routes } from 'react-router-dom';

import { AuthApp } from './AuthApp';
import { AdminShell } from './AdminShell';
import { RequireAdmin } from './RequireAdmin';
import { AnnouncementsPage } from './features/announcements';
import { AuditPage } from './features/audit';
import { AdminHomePage } from './features/home';
import { PlansPage } from './features/plans';
import { SettingsPage } from './features/settings';
import { TenantDetailPage, TenantsPage } from './features/tenants';
import { UsersPage } from './features/users';

export function AdminRoutes(): JSX.Element {
  return (
    <Routes>
      <Route path="/auth/*" element={<AuthApp />} />
      <Route
        path="/"
        element={
          <RequireAdmin>
            <AdminShell />
          </RequireAdmin>
        }
      >
        <Route index element={<AdminHomePage />} />
        <Route path="tenants" element={<TenantsPage />} />
        <Route path="tenants/:tenantId" element={<TenantDetailPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="billing" element={<Navigate to="/billing/plans" replace />} />
        <Route path="billing/plans" element={<PlansPage />} />
        <Route path="audit" element={<AuditPage />} />
        <Route path="announcements" element={<AnnouncementsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
